import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { NgxI18nRootService } from '@studiohyperdrive/ngx-i18n';
import { ObservableBoolean } from '@studiohyperdrive/rxjs-utils';
import { map } from 'rxjs';

import { AppRoutePaths, ELoketRoutePaths } from '@vlaio/shared/route-paths';

import { ApplicationService } from '../services';

export const HasProductGuard: CanActivateFn = (): ObservableBoolean => {
	// Wouter: Load the services.
	const applicationService: ApplicationService = inject(ApplicationService);
	const router: Router = inject(Router);
	const i18nRootService: NgxI18nRootService = inject(NgxI18nRootService);

	// Wouter: Check if a product is stored. If not, navigate to the products page
	return applicationService.state.product$.pipe(
		map((product) => {
			if (!!Object.keys(product ?? {}).length) {
				return true;
			}

			router.navigate(['/', i18nRootService.currentLanguage, AppRoutePaths.Loket, ELoketRoutePaths.Products]);
			return false;
		})
	);
};
